var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialieColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6171 8.1005L19.7403 5.57934C18.9264 4.41302 17.794 3.44697 16.4139 2.81079C12.2147 0.855126 7.23693 2.6812 5.29065 6.87527C3.83979 9.98547 4.47676 13.5316 6.62356 15.9467L14.9159 6.08593C15.9775 6.58074 16.8858 7.27582 17.6171 8.1005Z",
    fill: "#FC2361"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.32441 17.9731C8.26281 17.4783 7.35454 16.7833 6.62321 15.9586L4.5 18.4797C5.3139 19.6461 6.44628 20.6121 7.82637 21.2483C12.0256 23.1922 17.0034 21.3661 18.9496 17.172C20.4005 14.0618 19.7635 10.5157 17.6167 8.10059L9.32441 17.9731Z",
    fill: "#5CC7EA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.32473 17.9731L17.6171 8.1005C16.8857 7.27583 15.9775 6.58074 14.9159 6.08594L6.62354 15.9467C7.35486 16.7714 8.26313 17.4665 9.32473 17.9731Z",
    fill: "#54205A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialieColor);
export default __webpack_public_path__ + "static/media/socialie-color.6de05675ae37dc3451a5f3648b4d1f5f.svg";
export { ForwardRef as ReactComponent };